import { Toaster as SonnerToaster } from 'sonner';

/** 成功提示的绿色对勾（白勾 + 绿色实心圆）。 */
function SuccessIcon() {
  return (
    <svg viewBox="0 0 20 20" className="h-5 w-5 shrink-0 text-emerald-500" fill="currentColor">
      <circle cx="10" cy="10" r="10" />
      <path
        d="M6 10.5l2.5 2.5L14 7.5"
        fill="none"
        stroke="#fff"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** 失败提示的红色叹号（白色感叹号 + 红色实心圆）。 */
function ErrorIcon() {
  return (
    <svg viewBox="0 0 20 20" className="h-5 w-5 shrink-0 text-red-500" fill="currentColor">
      <circle cx="10" cy="10" r="10" />
      <path d="M10 5.5v5" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="10" cy="14" r="1.1" fill="#fff" />
    </svg>
  );
}

export function Toaster() {
  return (
    <SonnerToaster
      position="top-center"
      duration={3000}
      offset="74px"
      icons={{ success: <SuccessIcon />, error: <ErrorIcon /> }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex items-center gap-2.5 rounded-lg border border-border bg-card px-4 py-3 text-sm text-card-foreground shadow-sm animate-fade-in',
          title: 'font-medium',
          success:
            'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/30 dark:bg-emerald-500/10 dark:text-emerald-400',
          error:
            'border-red-200 bg-red-50 text-red-700 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-400',
        },
      }}
    />
  );
}
